export class StickyVideo {
  constructor(player, header) {
    this.playerElem = player;
    if (window.breakpoint == 1) {
      this.header = header.length > 80 ? header.substring(0, 80) + "..." : header;
    } else if (window.breakpoint == 2) {
      this.header = header.length > 90 ? header.substring(0, 90) + "..." : header;
    } else {
      this.header = header;
    }
    this.arrowSvg = `<svg width="17" height="28" viewBox="0 0 17 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-391.000000, -124.000000)" fill="#FFFFFF"><g transform="translate(394.142136, 138.142136) rotate(-315.000000) translate(-394.142136, -138.142136) translate(384.142136, 128.142136)"><rect x="-2.27373675e-13" y="-1.13686838e-13" width="19.5226344" height="3.48769053"></rect><polygon points="16.4683385 19.3866021 16.4683385 0.553073235 19.956029 0.553073235 19.956029 19.3866021"></polygon></g></g></g></svg>`;
    this.persistantVidClass = "persistant-video";
  }

  init() {
    this.addContainerHeaderElem();
    this.addDockedControls();
    this.addScrollEvent();
    this.disableStickyVideo();
  }

  setStickyTitle(title, _isIfi = false, _skip = false) {
    this.header = title;
    if (window.breakpoint == 1) {
      this.header =
        this.header.length > 80
          ? this.header.substring(0, 80) + "..."
          : this.header;
    } else if (window.breakpoint == 2) {
      this.header =
        this.header.length > 90
          ? this.header.substring(0, 90) + "..."
          : this.header;
    }
    if (_isIfi) {
      this.header = title.title;
      const ifiData = {
        ifiContent: title["html-content"] ? title["html-content"] : "",
        jobCodes: title.jobCode ? title.jobCode : ((title.playlist && title.playlist.jobCode) ? title.playlist.jobCode : "")
      }
      const skipIfi = _skip ? `<div class="eed-skip persistant">
      <p class="eed-skip-text">Program will commence after this Information from Industry.</p>
      <button class="eed-skip-button">Skip</button>
      <div class="close"></div>
      </div>`: ``;
      $(".persistent-header").addClass(`ifi-wrapper ${_skip ? 'skip':''}`);
      $(".persistent-header .persistent-header-title").html(
        ` <span>Information from Industry</span>
          <div>${this.titleHtmlSupport(this.header)}</div>
          <p>${ifiData.ifiContent}</p>
          <p>${ifiData.jobCodes}</p>
          ${skipIfi}`
      );
      if($(".docked-controls").length > 0) {
        $(".docked-controls").addClass("ifi");
      }
    } else {
      $(".persistent-header .persistent-header-title").removeClass('ifi-wrapper');
      $(".persistent-header").length > 0
        ?$(".persistent-header .persistent-header-title").text(this.header)
        : "";
        if($(".docked-controls.ifi").length > 0) {
          $(".docked-controls").removeClass("ifi");
        }
    }
  }

  setIFIVideo(ifiTitle, ref) {
    $(".persistent-header-playlist").empty();
    if (ifiTitle && ref) {
      const _html = `<a class="up-next" href="javascript:void(0)">
      <div class="content">
        <h4>Up Next</h4>
        <div class="sticky-ifi-tag">Information From Industry</div>
        <div class="playlist-title">${this.titleHtmlSupport(ifiTitle, 24)}</div>
      </div>
      <div class="arrow">
          ${this.arrowSvg}
      </div>
    </a>`;
      $(".persistent-header-playlist").html(_html);
      $(".up-next").click(function(e) {
        if($(".sticky-ifi-tag").length > 0) {
          $(ref).click();
        }
      });
    }
  }

  setNextVideo(url = "", _title = "") {
    $(".persistent-header-playlist").empty();
    if (url && _title) {
      const _html = `<a class="up-next" href="${url}">
      <div class="content">
        <h4>Up Next</h4>
        <div class="playlist-title">${_title.length > 50
          ? _title.substring(0, 50) + "..."
          : _title}</div>
      </div>
      <div class="arrow">
          ${this.arrowSvg}
      </div>
    </a>`;
      $(".persistent-header-playlist").html(_html);
    }
  }

  setCurrentVideo(_title , ref) {
		$(".persistent-header-playlist").empty();
		if (_title,ref) {
		  const _html = `<a class="up-next" href="javascript:void(0)">
		  <div class="content">
			<h4>Up Next</h4>
			<div class="playlist-title">${_title.length > 50
			  ? _title.substring(0, 50) + "..."
			  : _title}</div>
		  </div>
		  <div class="arrow">
			  ${this.arrowSvg}
		  </div>
		</a>`;
		  $(".persistent-header-playlist").html(_html);
      $(".up-next").click(function(e) {
          $(ref).click();
      });
		}
	  }

  addScrollEvent(scroll = true) {
    const detectScroll = () => {
      this.detectScrollPosition();
    }; 
    if(scroll) {
      window.addEventListener("scroll", detectScroll);
    } else {
      window.removeEventListener("scroll", detectScroll);
      $(this.playerElem).removeClass("persistant-video");
      $(".persistent-header").length >= 1 ? $(".persistent-header").remove() : "";
      $(".video-placeholder").length >= 1 ? $(".video-placeholder").remove() : "";
      $(".docked-controls").removeClass("show");
      this.persistantVidClass = "";
    }
  }

  detectScrollPosition() {
    let top = $(window).scrollTop();
    if (typeof mscpA2A === 'undefined' || !mscpA2A) {
		let elementOffset = $(".video-placeholder-ref").offset().top;
		if (elementOffset - top < 0) {
		  if ($(".persistant-video").length === 0) {
			$(this.playerElem).addClass(this.persistantVidClass);
			if(this.persistantVidClass != "") {
			  $(".persistent-header").show();
			  $(".video-placeholder").show();
			  $(".docked-controls").addClass("show");
			}
		  }
		} else {
		  $(this.playerElem).removeClass("persistant-video");
		  $(".persistent-header").length >= 1 ? $(".persistent-header").hide() : "";
		  $(".video-placeholder").length >= 1 ? $(".video-placeholder").hide() : "";
		  $(".docked-controls").removeClass("show");
		}
    } else {
		if (document.querySelector(this.playerElem) != null) {
			let a2aParEl = document.querySelector(this.playerElem).closest('.recap-article');
			let elementOffset = a2aParEl.querySelector('.video-placeholder-ref').getBoundingClientRect().top + top;
			let artEndPos = a2aParEl.querySelector('.recap-back-btn').getBoundingClientRect().top + top - document.querySelector('.persistent-header').offsetHeight;
			if (top > elementOffset && top < artEndPos) {
			  if (a2aParEl.querySelector('.persistant-video') === null) {
				a2aParEl.querySelector('.svp-module').classList.add("persistant-video");
				if (a2aParEl.querySelector('.persistent-header') !== null) {
				  a2aParEl.querySelector('.persistent-header').style.display = "block";
				}
				if (a2aParEl.querySelector('.video-placeholder') !== null) {
				  a2aParEl.querySelector('.video-placeholder').style.display = "block";
				}
				if (a2aParEl.querySelector('.docked-controls') !== null) {
				  a2aParEl.querySelector('.docked-controls').classList.add('show');
				}
			  }
			} else {
			  a2aParEl.querySelector('.svp-module').classList.remove("persistant-video");
			  if (a2aParEl.querySelector('.persistent-header') !== null) {
				a2aParEl.querySelector('.persistent-header').style.display = "none";
			  }
			  if (a2aParEl.querySelector('.video-placeholder') !== null) {
				a2aParEl.querySelector('.video-placeholder').style.display = "none";
			  }
			  if (a2aParEl.querySelector('.docked-controls') !== null) {
				a2aParEl.querySelector('.docked-controls').classList.remove('show');
			  }
			}
		}
    }
  }
  addContainerHeaderElem() {
    $(this.playerElem).after(
      `<div class="video-placeholder" style="display:none;"></div>
        <div class="persistent-header" style="display:none;">
          <div class="close-icon">&#x2716;</div>
          <div class="persistent-header-title">${this.header}</div>
          <div class="persistent-header-playlist">
            
          </div>
        </div>
        <div class="video-placeholder-ref"></div>`
    );
  }
  addDockedControls() {
    let _controls = `<div class="docked-controls"><div class="docked-controls-container">
    <div class="docked-controls-bkd"></div><div class="docked-controls-fwd"></div>
      <div class="docked-controls-speed">1.0X</div>
    </div></div>`;

    $(this.playerElem).after(_controls);
    this.controlsListener();
    return;
  }
  controlsListener() {
    $('.docked-controls-fwd').click(e=> {
      this.fwdBwd15Sec(15);
    });
    $('.docked-controls-bkd').click(e=> {
      this.fwdBwd15Sec(-15);
    });
    $('.docked-controls-speed').click(e=> {
      let _currentSpeed = $(e.target).text();
      _currentSpeed = parseFloat(_currentSpeed);
      _currentSpeed += .5;
      if(_currentSpeed >= 3) {
        _currentSpeed = 1;
      }
      this.playRateChange(_currentSpeed)
    });
  }

  playRateChange(rate) {
    const _vid = $(".decision-point").length > 0 ? document.querySelector('#cme-video-player video') : document.querySelector('#eed-video video');
    if(_vid != null) {
      _vid.playbackRate = rate;
      $('.docked-controls-speed').text(`${rate}X`);
    }
  }
  fwdBwd15Sec(sec) {
    const _vid = $(".decision-point").length > 0 ? document.querySelector('#cme-video-player video') : document.querySelector('#eed-video video');
    if(_vid != null) {
      _vid.currentTime = _vid.currentTime + sec;
    }
  }
  disableStickyVideo () {
    const _closeIcon = $(".persistent-header .close-icon");
    if(_closeIcon.length > 0) {
      _closeIcon.click(e => {
        this.addScrollEvent(false);
      })
    }
  }
  titleHtmlSupport(title, charLimit = 40) {
    if (this.containsHTML(title)) {
      if (title.length > charLimit) {
        const regex = /<[^>]*>/g;
        const tags = title.match(regex);
        let _title = `${this.removeIncompleteTags(title.substring(0, charLimit))}...`;
        for (let index = 0; index < tags.length; index++) {
          if (_title.indexOf(tags[index]) < 0) {
            _title += tags[index]
          }
        }
        return _title
      }
      return title;
    } else {
      return title.length > charLimit
        ? title.substring(0, charLimit) + "..."
        : title
    }
  }
  containsHTML(str) {
    const regex = /<[^>]*>/;
    return regex.test(str);
  }
  removeIncompleteTags(str) {
    const regex = /<\/[^>]*$/;
    let result = str.replace(regex, '');
    result = result[result.length - 1] === "<" ? result.substring(0, result.length - 1) : result;
    return result
  }
}
